import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';

const styles = theme => ({
	field: {
		width: '40px',
		height: '22px',
		padding: 0,
		paddingRight: '4px',
		marginTop: theme.spacing.unit * 1.5,

		color: theme.palette.grey[300],
		background: theme.palette.grey[600],
		border: 'none',
		borderRadius: '2px',
		textAlign: 'right',
		fontSize: '12px',
		'&:focus': {
			border: '1px solid',
			borderColor: theme.palette.primary[400]
		}
	},
	error: {
		color: theme.palette.error[400],
		border: '1px solid',
		borderColor: `${theme.palette.error[400]}!important`
	}
});

const DashboardInput = ({classes, error, ...rest}) => (
	<input
		type="text"
		className={`${classes.field} ${error ? classes.error : ''}`}
		{...rest}
	/>
);

DashboardInput.propTypes = {
	classes: PropTypes.object.isRequired,
	error: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.number
};

export default withStyles(styles)(DashboardInput);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer-dashboard/dashboard-input/index.jsx